import { motion, useAnimate, type AnimationSequence } from 'framer-motion'
import { useEffect } from 'react'
import { useTranslate } from '../../../../hooks/language/use-translate'
import { useGlobalStore } from '../../../../store/global-store'
import type { LiveBubbleMessage } from '../../../../types/lives/live'

interface Props {
  toast: LiveBubbleMessage
}

export function Toast({ toast }: Props) {
  const remove = useGlobalStore((state) => state.removeBubbleMessageLive)

  const [scope, animate] = useAnimate()

  const { translate } = useTranslate()

  useEffect(() => {
    const sequence: AnimationSequence = [
      [scope.current, { x: -window.innerWidth }, { duration: 25 }],
    ]

    if (toast) {
      animate(sequence).then(() => remove(toast.id as string))
    }
  }, [toast, scope, animate, remove])

  const user = toast?.user
  const isInvisible = user?.privacy?.invisibleVisitor

  const extendedData = toast?.extendedData
  const isGameType = toast?.extendedData?.type === 'game-luck-gift-box'

  return (
    <motion.div
      ref={scope}
      className="inline-flex max-w-[calc(100vw-36px)] min-w-0 flex-row items-center gap-y-2 rounded-lg border border-white px-2 py-2 text-white"
      style={{
        backgroundImage: 'linear-gradient(to right, #4568DC80, #3B478180)',
        width: 'fit-content',
        x: window.innerWidth,
      }}
    >
      {!isGameType && (
        <>
          {user && (
            <div className="flex flex-row items-center gap-2 mr-1 shrink-0">
              <img
                src={isInvisible ? '' : user?.imgUser}
                className="w-6 h-6 bg-black rounded-full border"
              />

              {user?.username && (
                <span className="text-white text-xs shrink-0">
                  {isInvisible ? translate('invisible') : user?.username}:
                </span>
              )}
            </div>
          )}

          <span className="text-white text-xs min-w-0 break-words">
            {toast?.message}
          </span>
        </>
      )}

      {isGameType && (
        <>
          {user && (
            <div className="flex flex-row items-center gap-2 mr-1 shrink-0">
              <img
                src={isInvisible ? '' : user?.imgUser}
                className="w-6 h-6 bg-black rounded-full border"
              />

              {/* {user?.username && (
                <span className="text-white text-xs">
                  {isInvisible ? 'invisible' : user?.username}:
                </span>
              )} */}
            </div>
          )}

          <span className="text-white text-xs min-w-0 break-words">
            <span className="text-amber-300 font-bold">{user?.username}</span>{' '}
            {translate('toast-bubble-message-send-to')}{' '}
            <span className="text-amber-300 font-bold">
              {extendedData?.userReceivedName}
            </span>{' '}
            {translate('toast-bubble-message-and-earned')}{' '}
            <span className="text-green-400 font-bold">
              {extendedData?.gift?.value}
            </span>{' '}
            {translate('toast-bubble-message-with-gift')}{' '}
            <span className="text-amber-300 font-bold">
              {extendedData?.gift?.name}
            </span>
          </span>
        </>
      )}
    </motion.div>
  )
}
